enum YesOrNo {
  Yes = 'Oui',
  No = 'Non',
}

enum Frequency {
  LessOne = '< 1 fois par jour',
  Once = '1 fois par jour',
  Twice = '2 fois par jour',
  TheeTime = '3 fois par jour',
}

class MedForm {
  teethBrushing: YesOrNo;
  teethBrushingFrequency: Frequency;
  latestConsultationDate: Date;
  medicalHistory: string;
  treatments: string;

  constructor(
    teethBrushing: YesOrNo,
    teethBrushingFrequency: Frequency,
    latestConsultationDate: Date,
    medicalHistory = '',
    treatments = '',
  ) {
    this.teethBrushing = teethBrushing;
    this.teethBrushingFrequency = teethBrushingFrequency;
    this.latestConsultationDate = latestConsultationDate;
    this.medicalHistory = medicalHistory;
    this.treatments = treatments;
  }
}

const createEmptyMedForm = function () {
  return new MedForm(YesOrNo.Yes, Frequency.Once, new Date(2019, 1, 4, 15, 15, 42));
};

export { MedForm, YesOrNo, Frequency, createEmptyMedForm };
